import React, { useState, useEffect, Fragment } from "react";
import ResponseSwitcher from 'ReusableComponents/ResponseSwitcher';
import cloneDeep from "lodash.clonedeep";
import unescape from "lodash/unescape";
import { Badge, Icon, Tooltip } from 'antd';
import TranslatedText from "translations/TranslatedText";

export default function SameForAll(props) {
  const { form, inputData, questionsKey, language, onCheckAnswer, checkAnswer } = props,
    { required, questions, defaultValue, id, options: defaultOptions } = inputData,
    { getFieldDecorator } = form;
  let correctValues = [];
  let correctLabels = [];
  const options = defaultOptions[language].map((defaultOption, index) => {
    if (defaultOption.is_answer) {
      correctValues.push(String(index));
      correctLabels.push(defaultOption.value);
    }
    return {
      value: String(index),
      label: defaultOption.value,
      is_answer: defaultOption.is_answer,
      select: defaultOption.select,
    }
  });
  const paragraph = unescape(questions[language].replace(/( |<([^>]+)>)/ig, "")).split("<select>");
  const [state, setState] = useState({
    values: options.map((option) => option.value),
    labels: options.map((option) => option.label),
    correctValues: correctValues,
    correctLabels: correctLabels,
  });
  const toolTipText = <TranslatedText id="render.question.selectblanktext.tooltip" />

  useEffect(() => {
    setState({
      values: options.map((option) => option.value),
      labels: options.map((option) => option.label),
      correctValues: correctValues,
      correctLabels: correctLabels,
    })
  }, [defaultOptions]);

  const onChange = (index, selectedOption) => {
    const valuesClone = cloneDeep(state.values);
    valuesClone[index] = selectedOption.value;

    const labelsClone = cloneDeep(state.labels);
    labelsClone[index] = selectedOption.label;

    setState({
      values: valuesClone, labels: labelsClone,
      correctValues, correctLabels
    })
  }

  useEffect(() => {
    if (checkAnswer) {
      let value = '';
      for (let index = 0; index < paragraph.length-1; index++) {
        if (index < paragraph.length-2) {
          value = value + state.labels[index] + ',';
        } else {
          value = value + state.labels[index];
        }
      }
      onCheckAnswer(id, value, questionsKey);
    }
  }, [checkAnswer])

  return (
    <Fragment>
      {paragraph.map((sentence, index) => {
        const value = state.values[index];
        const label = state.labels[index];
        return (
          <Fragment key={index}>
            {sentence}
            {
              index < (paragraph.length-1) ?
              <Fragment>
                {"( "}
                <Badge count={
                  <Tooltip placement="top" title={toolTipText}>
                    {!checkAnswer && <Icon type="question-circle"/>}
                  </Tooltip>
                }>
                  {
                    !checkAnswer && (
                      <ResponseSwitcher onChange={(v,s)=>onChange(index,s[0])}
                                        value={value} label={label}
                                        options={options}
                      />
                    )
                  }
                  {
                    checkAnswer && state.correctValues.includes(value) && (
                      <ResponseSwitcher onChange={(v,s)=>onChange(index,s[0])}
                                        value={value} label={label}
                                        options={options}
                                        styles={{
                                          color: '#1C9E11',
                                          cursor: 'text'
                                        }}
                                        disabled={true}
                      />
                    )
                  }
                  {
                    checkAnswer && !state.correctValues.includes(value) && (
                      <Fragment>
                        <ResponseSwitcher onChange={(v,s)=>onChange(index,s[0])}
                                          value={value} label={label}
                                          options={options}
                                          styles={{
                                            textDecoration: 'line-through',
                                            color: '#DB2728',
                                            cursor: 'text'
                                          }}
                                          disabled={true}
                        />
                        <ResponseSwitcher onChange={(v,s)=>onChange(index,s[0])}
                                          value={state.correctValues.toString()}
                                          label={state.correctLabels.toString()}
                                          options={options}
                                          styles={{
                                            color: '#1C9E11',
                                            cursor: 'text'
                                          }}
                                          disabled={true}
                        />
                      </Fragment>
                    )
                  }
                </Badge>
                {" )"}
              </Fragment>
              : null
            }
          </Fragment>
        )
      })}
    </Fragment>
  )
};
